/**
 * Represents the Base API service.
 */
export default abstract class BaseApiService {
  private readonly baseUrl: string
  constructor(endpoint: string) {
    this.baseUrl = endpoint
  }

  /**
   * Sends an asynchronous GET request.
   * @param {string} requestUri - The request URI.
   * @returns {TResponseType} Response type wrapped in a Promise.
   */
  public async GetAsync<TResponseType extends object>(
    requestUri: string
  ): Promise<TResponseType> {
    return await this.SendAsync<TResponseType>(
      'GET',
      this.baseUrl.concat(requestUri)
    )
  }

  /**
   * Sends an asynchronous POST request.
   * @param {string} requestUri - The request URI.
   * @returns {TResponseType} Response type wrapped in a Promise.
   */
  public async PostAsync<TResponseType extends object>(
    requestUri: string
  ): Promise<TResponseType> {
    return await this.SendAsync<TResponseType>(
      'POST',
      this.baseUrl.concat(requestUri)
    )
  }

  /**
   * Sends an asynchronous request.
   * @param {string} method - The request method e.g. 'GET'.
   * @param {string} requestUri - The request URI.
   * @returns {TResponseType} Response type wrapped in a Promise.
   */
  private async SendAsync<TResponseType extends object>(
    method: string,
    requestUrl: string
  ): Promise<TResponseType> {
    const response = await fetch(requestUrl, {
      method: method,
      headers: { 'Content-Type': 'application/json' },
    })

    if (!response.ok) {
      // @ts-ignore: 'Error' constructor arguments
      throw new Error('ApiService: There was an error calling the API.', {
        cause: response.status,
      })
    }

    return await response.json()
  }
}
